import { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import config from '../devprodConfig';

const apiurl = config.apiBaseUrl;
const maptemplate = config.mapTileTemplate;

// markers: [{ coords: [lat, lng], label: string }]
export default function MultiMarkerMap({ markers = [], height = '300px' }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || markers.length === 0) return;

    L.Icon.Default.mergeOptions({
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });

    const map = L.map(containerRef.current, {
      zoom: 15,
      scrollWheelZoom: false,
    });

    const template = apiurl + maptemplate;
    const getTileUrl = (layerName) =>
      template
        .replace('{layerName}', layerName)
        .replace('{tileMatrixSet}', 'WGS84_Pseudo-Mercator');

    const layerBasePublic = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    });
    const layerBaseMap = L.tileLayer(getTileUrl('taustakartta'), { attribution: '&copy; Maanmittauslaitos', detectRetina: true });
    const layerIlmakuva = L.tileLayer(getTileUrl('ortokuva'), { attribution: '&copy; Maanmittauslaitos', detectRetina: true });

    const layerKiinteistorajat = L.tileLayer(getTileUrl('kiinteistojaotus'), { detectRetina: true });
    const layerKiinteistotunnus = L.tileLayer(getTileUrl('kiinteistotunnukset'), { detectRetina: true });

    layerBaseMap.addTo(map);
    layerKiinteistorajat.addTo(map);
    layerKiinteistotunnus.addTo(map);

    L.control.layers(
      { 'OpenStreetMap': layerBasePublic, 'Taustakartta': layerBaseMap, 'Ilmakuva': layerIlmakuva },
      { 'Kiinteistörajat': layerKiinteistorajat, 'Kiinteistötunnukset': layerKiinteistotunnus },
      { collapsed: true }
    ).addTo(map);

    const leafletMarkers = markers.map(({ coords, label }) => {
      const m = L.marker(coords).addTo(map);
      if (label) m.bindPopup(label);
      return m;
    });

    if (leafletMarkers.length === 1) {
      map.setView(markers[0].coords, 16);
    } else {
      const group = L.featureGroup(leafletMarkers);
      map.fitBounds(group.getBounds().pad(0.15), { maxZoom: 16 });
    }

    return () => { map.remove(); };
  }, [markers.length]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div ref={containerRef} style={{ height, width: '100%', borderRadius: 10 }} />
  );
}
